import React, { useState } from "react";
import Homepage from "./carburn-homepage.png";
import img1 from "./img1.svg";
import img2 from "./img2.svg";
import LoginC from "./LoginC";
import SignupC from "./SignupC";
import ResetPasswords from "./ResetPasswords";
import { Link } from "react-scroll";
import ResetPasswordForm from "./ResetPasswordForm";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import PermissionForm from "./PermissionForm";
import { ReactComponent as Logo } from "../../assets/svgs/sidebarlogo.svg";
import { ReactComponent as Whitelogo } from "../../assets/svgs/Carburn-whitelogo.svg";
import PopupCard from "./PopupCard";
const Logins = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [showPermission, setPermission] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const [showResetpassword, setShowResetpassword] = useState(false);
  const [showResetPasswordwithmail, setShowResetPasswordwithmail] =
    useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navigate = useNavigate();

  // useEffect(() => {
  //   if (showResetPasswordwithmail) {
  //     navigate('/reset-password');
  //   }
  // }, [showResetPasswordwithmail, navigate]);

  return (
    <div className="min-h-screen bg-white text-[16px] md:text-[17px]">
      <header className="bg-white shadow-sm border-b sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <span className="text-3xl font-bold text-[#06513D]">
                  <Logo className="inline-block w-40 h-40 mr-1" />
                </span>
              </div>
            </div>

            {/* Navigation - Desktop */}
            <nav className="hidden md:flex space-x-8 text-base font-medium">
              <a
                href="#"
                className="text-gray-700 hover:text-[#06513D] transition-colors"
              >
                Features
              </a>
              <a
                href="#"
                className="text-gray-700 hover:text-[#06513D] transition-colors"
              >
                How it Works
              </a>
              <a
                href="#"
                className="text-gray-700 hover:text-[#06513D] transition-colors"
              >
                Testimonials
              </a>
              <a
                href="#"
                className="text-gray-700 hover:text-[#06513D] transition-colors"
              >
                Pricing
              </a>
              <a
                href="#"
                className="text-gray-700 hover:text-[#06513D] transition-colors"
              >
                Contact
              </a>
            </nav>

            {/* Action Buttons - Desktop */}
            <div className="hidden md:flex items-center space-x-2">
              {/* <button style={{ border: "1px solid red" }} onClick={() => setShowResetPasswordwithmail(true)}>res</button> */}
              {/* <button
                className="bg-white text-[#06513D] border border-[#06513D] px-4 py-2 rounded-md hover:bg-green-50 transition-colors"
                onClick={() => setPermission(true)}
              >
                Allow
              </button> */}

              <button
                className="bg-white text-[#06513D] border border-[#06513D] px-4 py-2 rounded-md text-base hover:bg-green-50 transition-colors"
                onClick={() => setShowLogin(true)}
              >
                Log In
              </button>
              <button
                onClick={() => setShowSignup(true)}
                className="text-white bg-[#06513D] border border-[#06513D] px-4 py-2 rounded-md text-base transition-colors"
              >
                Sign Up
              </button>
            </div>

            {/* Mobile Menu Button */}
            <div className="md:hidden">
              <button
                className="text-gray-700 hover:text-green-600"
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              >
                {isMobileMenuOpen ? (
                  <svg
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                ) : (
                  <svg
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                )}
              </button>
            </div>
          </div>

          {/* Mobile Menu - Side Panel */}
          {isMobileMenuOpen && (
            <div className="md:hidden fixed inset-0 z-50">
              {/* Backdrop */}
              <div
                className="fixed inset-0 bg-black bg-opacity-50"
                onClick={() => setIsMobileMenuOpen(false)}
              ></div>

              {/* Side Panel */}
              <div className="fixed top-0 right-0 h-full w-80 bg-white shadow-lg transform transition-transform duration-300 ease-in-out">
                {/* Header */}
                <div className="flex justify-between items-center p-4 border-b border-gray-200">
                  <span className="text-2xl font-bold text-[#06513D]">
                    <Logo className="inline-block w-40 h-40 mr-1" />
                  </span>
                  <button
                    className="text-gray-700 hover:text-green-600"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    <svg
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>

                {/* Navigation */}
                <nav className="px-4 py-6 space-y-4 text-base">
                  <a
                    href="#"
                    className="block px-3 py-2 text-gray-700 hover:text-green-600 transition-colors"
                  >
                    Features
                  </a>
                  <a
                    href="#"
                    className="block px-3 py-2 text-gray-700 hover:text-green-600 transition-colors"
                  >
                    How it Works
                  </a>
                  <a
                    href="#"
                    className="block px-3 py-2 text-gray-700 hover:text-green-600 transition-colors"
                  >
                    Testimonials
                  </a>
                  <a
                    href="#"
                    className="block px-3 py-2 text-gray-700 hover:text-green-600 transition-colors"
                  >
                    Pricing
                  </a>
                  <a
                    href="#"
                    className="block px-3 py-2 text-gray-700 hover:text-green-600 transition-colors"
                  >
                    Contact
                  </a>
                </nav>

                {/* Action Buttons */}
                <div className="px-4 py-6 border-t border-gray-200 space-y-3">
                  {/* <button style={{ border: "1px solid red" }} onClick={() => setShowResetPasswordwithmail(true)}>res</button> */}
                  <button
                    className="w-full bg-white text-[#06513D] border border-[#06513D] px-4 py-2 rounded-md text-base hover:bg-green-50 transition-colors"
                    onClick={() => setShowLogin(true)}
                  >
                    Log In
                  </button>
                  <button
                    onClick={() => setShowSignup(true)}
                    className="w-full text-white bg-[#06513D] border border-[#06513D] px-4 py-2 rounded-md text-base transition-colors"
                  >
                    Sign Up
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </header>

      <section className="bg-[#06513D] text-white py-20 relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                Simplify Your ESG Reporting &
                <br />
                Carbon Footprint
                <br />
                Management
              </h1>
              <p className="text-xl mb-8 text-green-100">
                CARBURN helps you track carbon footprints, set science-based
                targets, and achieve your sustainability goals with
                comprehensive reporting.
              </p>
              <div className="flex gap-2">
                <button
                  onClick={() => setShowSignup(true)}
                  className="bg-white text-[#06513D] px-8 py-3 rounded-md font-semibold hover:bg-gray-100 transition-colors"
                >
                  Get Started
                </button>
                <Link
                  to="how-it-works"
                  smooth={true}
                  duration={500}
                  offset={-80} // Optional: offset for fixed navbars
                >
                  <button className=" border border-[#ffff] text-white px-8 py-3 rounded-md font-semibold  transition-colors">
                    Learn More
                  </button>
                </Link>
              </div>
            </div>
            <div className="flex justify-center">
              <img
                src={Homepage}
                alt="Carburn Homepage"
                className="w-auto h-auto max-w-full"
                style={{
                  animation: "slowFloat 4s ease-in-out infinite",
                }}
              />
              <style jsx>
                {`
                  @keyframes slowFloat {
                    0%,
                    100% {
                      transform: translateY(0px);
                    }
                    50% {
                      transform: translateY(-20px);
                    }
                  }
                `}
              </style>
            </div>
          </div>
        </div>

        {/* Left side gradual downward curve */}
        <div className="absolute bottom-0 left-0 w-full overflow-hidden">
          <svg
            className="relative block w-full h-24"
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
          >
            <path
              d="M0,60 Q300,120 600,60 T1200,100 L1200,120 L0,120 Z"
              fill="white"
            ></path>
          </svg>
        </div>
      </section>
      <div className=" border-t border-[#06513D]"></div>
      {/* Trusted By Section */}
      <section className=" bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-center text-gray-600  text-xl mb-4 mt-4">
            Trusted by leading companies worldwide
          </p>
          <div className="flex justify-center items-center gap-4">
            <div className=" ">
              <img src={img1} />
            </div>
            <div className="">
              <img src={img2} />
            </div>
          </div>
        </div>
      </section>

      {/* Features Section with Animated Cards */}
      <section className="py-10 bg-white" id="how-it-works">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Powerful Features for ESG Management
            </h2>
            <p className="text-xl text-gray-600">
              CARBURN provides all the tools you need to measure, report, and
              improve your
              <br />
              organization's environmental performance.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Feature 1 - Animated */}
            <div className="bg-[#ffffff] rounded-md shadow-sm text-center p-6 hover:animate-pulse transition-all  duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <div className="w-8 h-8 text-[#06513D]">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                    />
                  </svg>
                </div>
              </div>
              <h3 className="text-xl font-semibold mb-3">
                Carbon Content Tracking
              </h3>
              <p className="text-gray-600 mb-4">
                Monitor your carbon footprint across all business operations,
                supply chains, and product lifecycle stages.
              </p>
              <ul className="text-sm text-gray-500 space-y-1">
                <li>✓ Scope 1, 2, 3 emissions</li>
                <li>✓ Real-time monitoring</li>
                <li>✓ Supply chain tracking</li>
                <li>✓ Product lifecycle analysis</li>
              </ul>
            </div>

            {/* Feature 2 - Animated */}
            <div className=" bg-[#ffffff] rounded-md shadow-sm text-center p-6 hover:animate-pulse transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <div className="w-8 h-8 text-[#06513D]">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                </div>
              </div>
              <h3 className="text-xl font-semibold mb-3">
                ESG Reporting & Compliance
              </h3>
              <p className="text-gray-600 mb-4">
                Generate comprehensive ESG reports that comply with global
                standards and regulatory requirements.
              </p>
              <ul className="text-sm text-gray-500 space-y-1">
                <li>✓ Automated report generation</li>
                <li>✓ Compliance with standards</li>
                <li>✓ Customizable dashboards</li>
                <li>✓ Data visualization</li>
              </ul>
            </div>

            {/* Feature 3 - Animated */}
            <div className="bg-[#ffffff] rounded-md shadow-sm text-center p-6 hover:animate-pulse transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <div className="w-8 h-8 text-[#06513D]">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
              </div>
              <h3 className="text-xl font-semibold mb-3">
                Reduction Strategy Planning
              </h3>
              <p className="text-gray-600 mb-4">
                Set science-based targets and develop actionable strategies to
                achieve your sustainability goals.
              </p>
              <ul className="text-sm text-gray-500 space-y-1">
                <li>✓ Science-based targets</li>
                <li>✓ Action plan development</li>
                <li>✓ Progress tracking</li>
                <li>✓ ROI analysis</li>
              </ul>
            </div>

            {/* Feature 4 - Animated */}
            <div className="bg-[#ffffff] rounded-md shadow-sm text-center p-6 hover:animate-pulse transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <div className="w-8 h-8 text-[#06513D]">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"
                    />
                  </svg>
                </div>
              </div>
              <h3 className="text-xl font-semibold mb-3">
                Stakeholder Engagement
              </h3>
              <p className="text-gray-600 mb-4">
                Engage stakeholders with transparent reporting and collaborative
                sustainability initiatives.
              </p>
              <ul className="text-sm text-gray-500 space-y-1">
                <li>✓ Stakeholder portals</li>
                <li>✓ Collaborative tools</li>
                <li>✓ Communication templates</li>
                <li>✓ Feedback systems</li>
              </ul>
            </div>

            {/* Feature 5 - Animated */}
            <div className="bg-[#ffffff] rounded-md shadow-sm text-center p-6 hover:animate-pulse transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <div className="w-8 h-8 text-[#06513D]">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"
                    />
                  </svg>
                </div>
              </div>
              <h3 className="text-xl font-semibold mb-3">
                Supply Chain Sustainability
              </h3>
              <p className="text-gray-600 mb-4">
                Track and improve sustainability across your entire supply chain
                network.
              </p>
              <ul className="text-sm text-gray-500 space-y-1">
                <li>✓ Supplier assessments</li>
                <li>✓ Risk identification</li>
                <li>✓ Performance monitoring</li>
                <li>✓ Improvement programs</li>
              </ul>
            </div>

            {/* Feature 6 - Animated */}
            <div className="bg-[#ffffff] rounded-md shadow-sm text-center p-6 hover:animate-pulse transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <div className="w-8 h-8 text-[#06513D]">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13 10V3L4 14h7v7l9-11h-7z"
                    />
                  </svg>
                </div>
              </div>
              <h3 className="text-xl font-semibold mb-3">
                Advanced Analytics & Insights
              </h3>
              <p className="text-gray-600 mb-4">
                Leverage AI-powered analytics to uncover insights and optimize
                your sustainability performance.
              </p>
              <ul className="text-sm text-gray-500 space-y-1">
                <li>✓ Predictive analytics</li>
                <li>✓ Trend analysis</li>
                <li>✓ Benchmarking</li>
                <li>✓ Optimization recommendations</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* How CARBURN Works - Single Column Layout */}
      <section className="py-10 ">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              How CARBURN Works
            </h2>
            <p className="text-xl text-gray-600">
              Our platform simplifies the complex process of ESG reporting and
              carbon
              <br />
              footprint management in just four easy steps.
            </p>
          </div>

          <div className="space-y-16">
            {/* Step 1 */}
            <div className="flex flex-col md:flex-row gap-4 w-[90%] md:w-[80%] m-auto">
              <div className="flex-1 w-full md:w-[50%] text-center md:text-left">
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 bg-[#E6F2EF] text-[#06513D] rounded-full flex items-center justify-center font-bold text-2xl mx-auto md:mx-0">
                    1
                  </div>
                </div>
                <h3 className="text-2xl font-semibold mb-4">Data Collection</h3>
                <p className="text-gray-600 text-lg mb-4">
                  Collect data from various sources including utility bills,
                  travel records, and supply chain partners through our
                  intuitive data collection tools.
                </p>
                <ul className="text-lg text-gray-500 space-y-2">
                  <li>✓ Automated data imports</li>
                  <li>✓ Manual data entry</li>
                  <li>✓ Third-party integrations</li>
                </ul>
              </div>

              <div className="flex-shrink-0 w-full md:w-[50%]">
                {/* <div className="w-full h-48 md:h-full bg-white rounded-lg shadow-sm border flex items-center justify-center">
                  <div className="w-8 h-8 text-gray-400">
                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                  </div>
                </div> */}
                <div class="bg-gray-100 rounded-xl p-4 shadow-inner">
                  <svg
                    class="w-full h-auto"
                    viewBox="0 0 400 250"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="20"
                      y="20"
                      width="360"
                      height="210"
                      rx="8"
                      fill="white"
                      stroke="#e2e8f0"
                    />
                    <rect
                      x="40"
                      y="40"
                      width="320"
                      height="50"
                      rx="4"
                      fill="#f1f5f9"
                    />
                    <rect
                      x="60"
                      y="55"
                      width="120"
                      height="20"
                      rx="2"
                      fill="#06513D"
                      opacity="0.2"
                    />
                    <rect
                      x="200"
                      y="55"
                      width="80"
                      height="20"
                      rx="2"
                      fill="#06513D"
                      opacity="0.2"
                    />
                    <rect
                      x="300"
                      y="55"
                      width="40"
                      height="20"
                      rx="2"
                      fill="#06513D"
                      opacity="0.2"
                    />

                    <rect
                      x="40"
                      y="110"
                      width="320"
                      height="1"
                      fill="#e2e8f0"
                    />

                    <rect
                      x="60"
                      y="130"
                      width="100"
                      height="10"
                      rx="2"
                      fill="#94a3b8"
                    />
                    <rect
                      x="60"
                      y="150"
                      width="280"
                      height="40"
                      rx="4"
                      fill="#f8fafc"
                      stroke="#e2e8f0"
                    />

                    <rect
                      x="300"
                      y="200"
                      width="40"
                      height="10"
                      rx="2"
                      fill="#06513D"
                    />
                  </svg>
                </div>
              </div>
            </div>

            {/* Step 2 */}
            <div className="flex flex-col md:flex-row gap-4 w-[90%] md:w-[80%] m-auto">
              <div className="flex-shrink-0 w-full md:w-[50%] order-2 md:order-1">
                <div class="bg-gray-100 rounded-xl p-4 shadow-inner">
                  <svg
                    class="w-full h-auto"
                    viewBox="0 0 400 250"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="20"
                      y="20"
                      width="360"
                      height="210"
                      rx="8"
                      fill="white"
                      stroke="#e2e8f0"
                    />

                    <rect
                      x="40"
                      y="40"
                      width="160"
                      height="170"
                      rx="4"
                      fill="#f8fafc"
                      stroke="#e2e8f0"
                    />
                    <path
                      d="M60,160 L80,140 L100,150 L120,120 L140,130 L160,110 L180,100"
                      stroke="#06513D"
                      stroke-width="3"
                      fill="none"
                    />
                    <text
                      x="100"
                      y="60"
                      font-family="Inter"
                      font-size="12"
                      font-weight="600"
                      fill="#1e293b"
                    >
                      Scope 1
                    </text>

                    <rect
                      x="220"
                      y="40"
                      width="160"
                      height="80"
                      rx="4"
                      fill="#f8fafc"
                      stroke="#e2e8f0"
                    />
                    <path
                      d="M240,100 L260,90 L280,95 L300,80 L320,85 L340,70 L360,65"
                      stroke="#06513D"
                      stroke-width="3"
                      fill="none"
                    />
                    <text
                      x="280"
                      y="60"
                      font-family="Inter"
                      font-size="12"
                      font-weight="600"
                      fill="#1e293b"
                    >
                      Scope 2
                    </text>

                    <rect
                      x="220"
                      y="130"
                      width="160"
                      height="80"
                      rx="4"
                      fill="#f8fafc"
                      stroke="#e2e8f0"
                    />
                    <path
                      d="M240,190 L260,180 L280,185 L300,170 L320,175 L340,160 L360,155"
                      stroke="#06513D"
                      stroke-width="3"
                      fill="none"
                    />
                    <text
                      x="280"
                      y="150"
                      font-family="Inter"
                      font-size="12"
                      font-weight="600"
                      fill="#1e293b"
                    >
                      Scope 3
                    </text>
                  </svg>
                </div>
              </div>
              <div className="flex-1 text-center md:text-left w-full md:w-[50%] md:pl-3 order-1 md:order-2">
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 bg-[#E6F2EF] text-[#06513D] rounded-full flex items-center justify-center font-bold text-2xl mx-auto md:mx-0">
                    2
                  </div>
                </div>
                <h3 className="text-2xl font-semibold mb-4">
                  Analysis & Calculation
                </h3>
                <p className="text-gray-600 mb-4 text-lg">
                  Our advanced algorithms analyze your data and calculate carbon
                  emissions across all scopes with industry-standard
                  methodologies.
                </p>
                <ul className="text-lg text-gray-500 space-y-2">
                  <li>✓ Scope 1, 2, 3 calculations</li>
                  <li>✓ Emission factor libraries</li>
                  <li>✓ Uncertainty analysis</li>
                </ul>
              </div>
            </div>

            {/* Step 3 */}
            <div className="flex flex-col md:flex-row gap-4 w-[90%] md:w-[80%] m-auto">
              <div className="flex-1 text-center md:text-left w-full md:w-[50%]">
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 bg-[#E6F2EF] text-[#06513D] rounded-full flex items-center justify-center font-bold text-2xl mx-auto md:mx-0">
                    3
                  </div>
                </div>
                <h3 className="text-2xl font-semibold mb-4">
                  Reporting & Visualization
                </h3>
                <p className="text-gray-600 mb-4 text-lg">
                  Generate comprehensive reports and interactive dashboards that
                  provide clear insights into your sustainability performance.
                </p>
                <ul className="text-lg text-gray-500 space-y-2">
                  <li>✓ Customizable reports</li>
                  <li>✓ Interactive dashboards</li>
                  <li>✓ Export capabilities</li>
                </ul>
              </div>
              <div className="flex-shrink-0 w-full md:w-[50%]">
                <div class="bg-gray-100 rounded-xl p-4 shadow-inner">
                  <svg
                    class="w-full h-auto"
                    viewBox="0 0 400 250"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="20"
                      y="20"
                      width="360"
                      height="210"
                      rx="8"
                      fill="white"
                      stroke="#e2e8f0"
                    />

                    <rect
                      x="40"
                      y="40"
                      width="320"
                      height="40"
                      rx="4"
                      fill="#f8fafc"
                      stroke="#e2e8f0"
                    />
                    <rect
                      x="60"
                      y="55"
                      width="100"
                      height="10"
                      rx="2"
                      fill="#06513D"
                      opacity="0.3"
                    />
                    <rect
                      x="180"
                      y="55"
                      width="60"
                      height="10"
                      rx="2"
                      fill="#06513D"
                      opacity="0.3"
                    />
                    <rect
                      x="260"
                      y="55"
                      width="80"
                      height="10"
                      rx="2"
                      fill="#06513D"
                      opacity="0.3"
                    />

                    <rect
                      x="40"
                      y="100"
                      width="150"
                      height="110"
                      rx="4"
                      fill="#f8fafc"
                      stroke="#e2e8f0"
                    />
                    <circle
                      cx="115"
                      cy="150"
                      r="40"
                      fill="none"
                      stroke="#e2e8f0"
                      stroke-width="10"
                    />
                    <path
                      d="M115,150 L115,110 A40,40 0 0,1 149.3,130 z"
                      fill="#06513D"
                    />
                    <path
                      d="M115,150 L149.3,130 A40,40 0 0,1 135,180 z"
                      fill="#06513D"
                      opacity="0.6"
                    />
                    <path
                      d="M115,150 L135,180 A40,40 0 0,1 85,170 z"
                      fill="#06513D"
                      opacity="0.4"
                    />
                    <path
                      d="M115,150 L85,170 A40,40 0 0,1 115,110 z"
                      fill="#06513D"
                      opacity="0.2"
                    />

                    <rect
                      x="210"
                      y="100"
                      width="150"
                      height="110"
                      rx="4"
                      fill="#f8fafc"
                      stroke="#e2e8f0"
                    />
                    <rect
                      x="230"
                      y="170"
                      width="20"
                      height="20"
                      rx="2"
                      fill="#06513D"
                    />
                    <rect
                      x="260"
                      y="150"
                      width="20"
                      height="40"
                      rx="2"
                      fill="#06513D"
                      opacity="0.8"
                    />
                    <rect
                      x="290"
                      y="130"
                      width="20"
                      height="60"
                      rx="2"
                      fill="#06513D"
                      opacity="0.6"
                    />
                    <rect
                      x="320"
                      y="110"
                      width="20"
                      height="80"
                      rx="2"
                      fill="#06513D"
                      opacity="0.4"
                    />
                  </svg>
                </div>
              </div>
            </div>

            {/* Step 4 */}
            <div className="flex flex-col md:flex-row gap-4 w-[90%] md:w-[80%] m-auto">
              <div className="flex-shrink-0 w-full md:w-[50%] order-2 md:order-1">
                <div className="w-full h-48 md:h-full bg-white rounded-lg shadow-sm border flex items-center justify-center">
                  <div className="w-8 h-8 text-green-600">
                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                </div>
              </div>

              <div className="flex-1 text-center md:text-left w-full md:w-[50%] md:pl-3 order-1 md:order-2">
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 bg-[#E6F2EF] text-[#06513D] rounded-full flex items-center justify-center font-bold text-2xl mx-auto md:mx-0">
                    4
                  </div>
                </div>
                <h3 className="text-2xl font-semibold mb-4">
                  Action & Improvement
                </h3>
                <p className="text-gray-600 mb-4 text-lg">
                  Set targets, track progress, and implement improvement
                  strategies with our action planning and monitoring tools.
                </p>
                <ul className="text-lg text-gray-500 space-y-2">
                  <li>✓ Target setting</li>
                  <li>✓ Progress tracking</li>
                  <li>✓ Improvement recommendations</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-10 text-sm text-center md:text-left">
            <div>
              <div className="h-15 mb-2">
                <Whitelogo />
              </div>
              <p className="text-gray-300">
                Simplifying ESG reporting and carbon footprint management for a
                sustainable future.
              </p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Product</h4>
              <ul className="space-y-2 text-gray-300">
                <li>
                  <a href="#" className="hover:text-green-400">
                    Features
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-green-400">
                    Pricing
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-green-400">
                    Integrations
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Company</h4>
              <ul className="space-y-2 text-gray-300">
                <li>
                  <a href="#" className="hover:text-green-400">
                    About
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-green-400">
                    Careers
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-green-400">
                    Contact
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Support</h4>
              <ul className="space-y-2 text-gray-300">
                <li>
                  <a href="#" className="hover:text-green-400">
                    Help Center
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-green-400">
                    Documentation
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-green-400">
                    Community
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className=" border-t border-gray-800 pt-4 flex justify-center items-center text-center text-gray-400 text-sm">
            <p className="m-0">&copy; 2025 CARBURN. All rights reserved.</p>
          </div>
        </div>
      </footer>

      {/* {showLogin && <LoginC onClose={() => setShowLogin(false)} />}

        {showSignup && <SignupC onClose={() => setShowSignup(false)} />}

          {showResetpassword && <ResetPasswords onClose={() => setShowResetpassword(false)} />} */}

      {showLogin && (
        <LoginC
          LoginConClose={() => setShowLogin(false)}
          onSignup={() => {
            setShowLogin(false);
            setShowSignup(true);
          }}
          onResetPassword={() => {
            setShowLogin(false);
            setShowResetpassword(true);
          }}
        />
      )}

      {showPermission && (
        <PermissionForm permissionConClose={() => setPermission(false)} />
      )}
      {showSignup && (
        <SignupC
          onCloseSignupC={() => setShowSignup(false)}
          onLogin={() => {
            setShowSignup(false);
            setShowLogin(true);
          }}
        />
      )}

      {showResetpassword && (
        <ResetPasswords
          onCloseReset={() => setShowResetpassword(false)}
          onBackToLogin={() => {
            setShowResetpassword(false);
            setShowLogin(true);
          }}
        />
      )}

      {showResetPasswordwithmail && (
        <ResetPasswordForm
          onCloseForm={() => {
            setShowResetPasswordwithmail(false);
            // setShowLogin(true);
          }}
        />
      )}
    </div>
  );
};

export default Logins;
